import React, { useEffect, useState } from 'react';
import { ArrowUp, ArrowDown, AlertTriangle, Search, ChevronDown, ChevronRight, Package } from 'lucide-react';
import api from '../../api/client';
import { useAuth } from '../../context/AuthContext';
import { puoFare } from '../../utils/permessi';

const API_BASE = (process.env.REACT_APP_API_URL || '/api').replace(/\/api$/, '');

export default function Warehouse() {
  const { user } = useAuth();
  const puoModificare = puoFare(user, 'prodotti', 'edit');
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState('');
  const [expanded, setExpanded] = useState({});
  const [modal, setModal] = useState(null);
  const [scortaModal, setScortaModal] = useState(null);
  const [qty, setQty] = useState('');
  const [tipo, setTipo] = useState('CARICO');
  const [note, setNote] = useState('');
  const [scortaVal, setScortaVal] = useState('');

  const load = () => api.get('/products').then(r => {
    setProducts(r.data);
    // Tutto collassato di default
    setExpanded({});
  });
  useEffect(() => { load(); }, []);

  const filtered = products.filter(p =>
    p.nome.toLowerCase().includes(search.toLowerCase()) ||
    p.sku_base.toLowerCase().includes(search.toLowerCase())
  );

  const totalStock = (p) => p.variants?.reduce((s, v) => s + (v.inventory?.quantita_disponibile || 0), 0) || 0;
  const hasAlert = (p) => p.variants?.some(v => v.scorta_minima > 0 && (v.inventory?.quantita_disponibile || 0) <= v.scorta_minima);

  const handleMovimento = async (e) => {
    e.preventDefault();
    await api.post(`/products/variants/${modal.variant.id}/inventory`, { quantita: parseInt(qty), tipo, note });
    setModal(null); setQty(''); setNote(''); load();
  };

  const handleScorta = async (e) => {
    e.preventDefault();
    await api.patch(`/products/variants/${scortaModal.variant.id}/scorta`, { scorta_minima: parseInt(scortaVal) });
    setScortaModal(null); setScortaVal(''); load();
  };

  return (
    <div>
      <div style={s.header}>
        <div>
          <h1 style={s.title}>MAGAZZINO</h1>
          <p style={s.sub}>Giacenze per prodotto e taglia — clicca su una taglia per movimentare</p>
        </div>
        <div style={s.stats}>
          <div style={s.statBox}>
            <div style={s.statVal}>{products.length}</div>
            <div style={s.statLabel}>PRODOTTI</div>
          </div>
          <div style={s.statBox}>
            <div style={s.statVal}>{products.reduce((s, p) => s + totalStock(p), 0)}</div>
            <div style={s.statLabel}>PEZZI TOT.</div>
          </div>
          <div style={{ ...s.statBox, borderColor: '#F59E0B40' }}>
            <div style={{ ...s.statVal, color: '#F59E0B' }}>{products.filter(hasAlert).length}</div>
            <div style={s.statLabel}>ALERT</div>
          </div>
        </div>
      </div>

      <div style={{ position:'relative', marginBottom:'20px' }}>
        <Search size={14} color="#555" style={{ position:'absolute', left:'12px', top:'50%', transform:'translateY(-50%)' }} />
        <input style={{ ...s.search, paddingLeft:'36px' }} placeholder="Cerca prodotto o SKU..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      {/* MODAL MOVIMENTO */}
      {modal && (
        <div style={s.overlay}>
          <div style={s.modalCard}>
            <div style={{ marginBottom:'20px' }}>
              <div style={s.modalTitle}>MOVIMENTA MAGAZZINO</div>
              <div style={{ color:'var(--text-dim)', fontSize:'var(--font-size-sm)', marginTop:'6px' }}>
                <span style={{ fontWeight:'700', color:'var(--text)' }}>{modal.productName}</span>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:'8px', marginTop:'6px' }}>
                <span style={s.tagliaPill}>{modal.variant.taglia}</span>
                <span style={{ color:'var(--text-dim)', fontSize:'var(--font-size-xs)' }}>{modal.variant.sku}</span>
                <span style={{ marginLeft:'auto', color:'var(--text-muted)', fontSize:'var(--font-size-xs)' }}>
                  Giacenza attuale: <strong style={{ color:'var(--text)' }}>{modal.variant.inventory?.quantita_disponibile || 0} pz</strong>
                </span>
              </div>
            </div>
            <form onSubmit={handleMovimento} style={{ display:'flex', flexDirection:'column', gap:'14px' }}>
              <div style={s.field}>
                <label style={s.label}>TIPO MOVIMENTO</label>
                <div style={{ display:'flex', gap:'8px' }}>
                  {[['CARICO', '+', '#22C55E'], ['RETTIFICA', '±', '#F59E0B']].map(([val, sym, col]) => (
                    <button key={val} type="button"
                      style={{ flex:1, padding:'10px', borderRadius:'8px', border:`1px solid ${tipo===val ? col+'60' : 'var(--border2)'}`, background: tipo===val ? col+'15' : 'var(--bg-input)', color: tipo===val ? col : 'var(--text-dim)', fontWeight:'700', fontSize:'var(--font-size-xs)', cursor:'pointer' }}
                      onClick={() => setTipo(val)}>
                      {sym} {val}
                    </button>
                  ))}
                </div>
              </div>
              <div style={s.field}>
                <label style={s.label}>QUANTITÀ {tipo === 'RETTIFICA' ? '(negativo per sottrarre)' : ''}</label>
                <input style={s.input} type="number" value={qty} onChange={e => setQty(e.target.value)} required autoFocus />
              </div>
              <div style={s.field}>
                <label style={s.label}>NOTE (opzionale)</label>
                <input style={s.input} value={note} onChange={e => setNote(e.target.value)} placeholder="es. DDT 123 del 15/03/2026" />
              </div>
              <div style={{ display:'flex', gap:'10px', justifyContent:'flex-end' }}>
                <button type="button" style={s.btnSec} onClick={() => setModal(null)}>ANNULLA</button>
                <button type="submit" style={s.btnPri}>CONFERMA</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL SCORTA */}
      {scortaModal && (
        <div style={s.overlay}>
          <div style={s.modalCard}>
            <div style={s.modalTitle} style={{ marginBottom:'16px' }}>SCORTA MINIMA</div>
            <div style={{ color:'var(--text-muted)', fontSize:'var(--font-size-xs)', marginBottom:'16px' }}>
              {scortaModal.productName} — <span style={s.tagliaPill}>{scortaModal.variant.taglia}</span>
            </div>
            <form onSubmit={handleScorta} style={{ display:'flex', flexDirection:'column', gap:'14px' }}>
              <div style={s.field}>
                <label style={s.label}>SOGLIA MINIMA (pz) — 0 = nessun alert</label>
                <input style={s.input} type="number" min="0" value={scortaVal} onChange={e => setScortaVal(e.target.value)} required autoFocus />
              </div>
              <div style={{ display:'flex', gap:'10px', justifyContent:'flex-end' }}>
                <button type="button" style={s.btnSec} onClick={() => setScortaModal(null)}>ANNULLA</button>
                <button type="submit" style={s.btnPri}>SALVA</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* LISTA PRODOTTI */}
      <div style={{ display:'flex', flexDirection:'column', gap:'10px' }}>
        {filtered.map(p => {
          const stock = totalStock(p);
          const alert = hasAlert(p);
          const isOpen = expanded[p.id];
          const img = p.immagine_url ? `${API_BASE}${p.immagine_url}` : null;
          const variantiAttive = p.variants?.filter(v => v.attiva) || [];

          return (
            <div key={p.id} style={{ ...s.productCard, ...(alert ? s.productCardAlert : {}) }}>
              {/* HEADER PRODOTTO */}
              <div style={s.productHeader} onClick={() => setExpanded(e => ({ ...e, [p.id]: !e[p.id] }))}>
                {/* Immagine */}
                <div style={s.productThumb}>
                  {img
                    ? <img src={img} alt={p.nome} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                    : <Package size={20} color="var(--text-dim)" />}
                </div>

                {/* Info prodotto */}
                <div style={{ flex:1 }}>
                  <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                    {alert && <AlertTriangle size={13} color="#F59E0B" />}
                    <span style={{ fontWeight:'700', fontSize:'var(--font-size-base)' }}>{p.nome}</span>
                    {p.category && <span style={s.catBadge}>{p.category.nome}</span>}
                  </div>
                  <div style={{ color:'var(--text-dim)', fontSize:'var(--font-size-xs)', marginTop:'3px', fontWeight:'700', letterSpacing:'1px' }}>{p.sku_base}</div>
                </div>

                {/* Taglie summary */}
                <div style={{ display:'flex', gap:'6px', alignItems:'center' }}>
                  {variantiAttive.map(v => {
                    const disp = v.inventory?.quantita_disponibile || 0;
                    const underStock = v.scorta_minima > 0 && disp <= v.scorta_minima;
                    return (
                      <div key={v.id} style={{ ...s.varChipSmall, ...(underStock ? s.varChipAlert : disp === 0 ? s.varChipZero : {}) }}>
                        <span style={{ fontSize: 'var(--font-size-xs)', color:'var(--text-dim)', fontWeight:'700' }}>{v.taglia}</span>
                        <span style={{ fontSize:'var(--font-size-sm)', fontWeight:'800' }}>{disp}</span>
                      </div>
                    );
                  })}
                </div>

                {/* Totale + toggle */}
                <div style={{ display:'flex', alignItems:'center', gap:'16px' }}>
                  <div style={{ textAlign:'right' }}>
                    <div style={{ fontFamily:"'Barlow Condensed'", fontSize:'var(--font-size-xl)', fontWeight:'800', color: stock > 0 ? 'var(--text)' : '#EF4444' }}>{stock}</div>
                    <div style={{ fontSize: 'var(--font-size-xs)', color:'var(--text-dim)', letterSpacing:'1px' }}>TOTALE PZ</div>
                  </div>
                  {isOpen ? <ChevronDown size={16} color="#555" /> : <ChevronRight size={16} color="#555" />}
                </div>
              </div>

              {/* DETTAGLIO TAGLIE */}
              {isOpen && (
                <div style={s.taglieDetail}>
                  <div style={s.taglieHeader}>
                    <span style={{ width:'80px' }}>TAGLIA</span>
                    <span style={{ flex:1 }}>SKU</span>
                    <span style={{ width:'80px', textAlign:'center' }}>DISP.</span>
                    <span style={{ width:'80px', textAlign:'center' }}>PREN.</span>
                    <span style={{ width:'100px', textAlign:'center' }}>SCORTA MIN.</span>
                    <span style={{ width:'100px', textAlign:'center' }}>AZIONI</span>
                  </div>
                  {variantiAttive.map(v => {
                    const disp = v.inventory?.quantita_disponibile || 0;
                    const pren = v.inventory?.quantita_prenotata || 0;
                    const underStock = v.scorta_minima > 0 && disp <= v.scorta_minima;
                    return (
                      <div key={v.id} style={{ ...s.tagliaRow, ...(underStock ? s.tagliaRowAlert : {}) }}>
                        <div style={{ width:'80px' }}>
                          <span style={s.tagliaPill}>{v.taglia}</span>
                        </div>
                        <div style={{ flex:1, fontSize:'var(--font-size-xs)', color:'var(--text-dim)', fontWeight:'700', letterSpacing:'1px' }}>{v.sku}</div>
                        <div style={{ width:'80px', textAlign:'center' }}>
                          <span style={{ fontSize: 'var(--font-size-xl)', fontWeight:'800', color: disp === 0 ? '#EF4444' : underStock ? '#F59E0B' : '#22C55E' }}>{disp}</span>
                        </div>
                        <div style={{ width:'80px', textAlign:'center' }}>
                          <span style={{ fontSize:'var(--font-size-sm)', color: pren > 0 ? '#F59E0B' : 'var(--text-dim)' }}>{pren}</span>
                        </div>
                        <div style={{ width:'100px', textAlign:'center' }}>
                          {puoModificare ? (
                            <button style={{ background:'transparent', border:'none', color: v.scorta_minima > 0 ? 'var(--text-muted)' : 'var(--text-dim)', fontSize:'var(--font-size-sm)', cursor:'pointer', textDecoration:'underline dotted' }}
                              onClick={() => { setScortaModal({ variant:v, productName:p.nome }); setScortaVal(v.scorta_minima); }}
                              title="Clicca per modificare">
                              {v.scorta_minima > 0 ? `≥ ${v.scorta_minima}` : '—'}
                            </button>
                          ) : (
                            <span style={{ color: v.scorta_minima > 0 ? 'var(--text-muted)' : 'var(--text-dim)', fontSize:'var(--font-size-sm)' }}>{v.scorta_minima > 0 ? `≥ ${v.scorta_minima}` : '—'}</span>
                          )}
                        </div>
                        <div style={{ width:'100px', display:'flex', gap:'6px', justifyContent:'center' }}>
                          {puoModificare && <button style={s.iconBtnGreen} title="Carico"
                            onClick={() => { setModal({ variant:v, productName:p.nome }); setTipo('CARICO'); setQty(''); setNote(''); }}>
                            <ArrowUp size={13} />
                          </button>}
                          {puoModificare && <button style={s.iconBtnOrange} title="Rettifica"
                            onClick={() => { setModal({ variant:v, productName:p.nome }); setTipo('RETTIFICA'); setQty(''); setNote(''); }}>
                            <ArrowDown size={13} />
                          </button>}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {filtered.length === 0 && (
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'12px', padding:'60px 0', color:'var(--text-dim)' }}>
          <Package size={40} color="var(--text-dim)" />
          <p>Nessun prodotto trovato</p>
        </div>
      )}
    </div>
  );
}

const s = {
  header: { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'20px' },
  title: { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', letterSpacing:'2px' },
  sub: { color:'var(--text-dim)', fontSize:'var(--font-size-sm)', marginTop:'4px' },
  stats: { display:'flex', gap:'10px' },
  statBox: { background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'10px', padding:'12px 20px', textAlign:'center' },
  statVal: { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-xl)', fontWeight:'800' },
  statLabel: { fontSize: 'var(--font-size-xs)', color:'var(--text-dim)', letterSpacing:'1.5px', fontWeight:'700', marginTop:'2px' },
  search: { width:'100%', background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'8px', padding:'11px 14px', color:'var(--text)', fontSize:'var(--font-size-sm)', outline:'none', boxSizing:'border-box' },
  productCard: { background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'12px', overflow:'hidden' },
  productCardAlert: { borderColor:'#F59E0B30' },
  productHeader: { display:'flex', alignItems:'center', gap:'16px', padding:'14px 20px', cursor:'pointer' },
  productThumb: { width:'48px', height:'48px', background:'var(--bg)', borderRadius:'8px', flexShrink:0, overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center' },
  catBadge: { background:'var(--border)', border:'1px solid var(--border2)', borderRadius:'4px', padding:'2px 8px', fontSize: 'var(--font-size-xs)', color:'var(--text-dim)' },
  varChipSmall: { display:'flex', flexDirection:'column', alignItems:'center', background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'6px', padding:'4px 8px', minWidth:'36px' },
  varChipAlert: { background:'#F59E0B10', border:'1px solid #F59E0B40' },
  varChipZero: { opacity:0.35, borderStyle:'dashed' },
  taglieDetail: { borderTop:'1px solid var(--border)' },
  taglieHeader: { display:'flex', alignItems:'center', padding:'8px 20px', background:'var(--bg)', fontSize: 'var(--font-size-xs)', letterSpacing:'1.5px', fontWeight:'700', color:'var(--text-dim)', gap:'8px' },
  tagliaRow: { display:'flex', alignItems:'center', padding:'12px 20px', borderTop:'1px solid #111', gap:'8px' },
  tagliaRowAlert: { background:'#F59E0B05', borderLeft:'2px solid #F59E0B30' },
  tagliaPill: { background:'var(--border)', border:'1px solid var(--border2)', borderRadius:'4px', padding:'3px 10px', fontSize:'var(--font-size-xs)', fontWeight:'700', color:'var(--text-muted)' },
  iconBtnGreen: { background:'#22C55E15', border:'1px solid #22C55E30', borderRadius:'6px', padding:'6px 8px', color:'#22C55E', cursor:'pointer', display:'flex', alignItems:'center' },
  iconBtnOrange: { background:'#F59E0B15', border:'1px solid #F59E0B30', borderRadius:'6px', padding:'6px 8px', color:'#F59E0B', cursor:'pointer', display:'flex', alignItems:'center' },
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.8)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 },
  modalCard: { background:'var(--bg-card)', border:'1px solid #222', borderRadius:'14px', padding:'28px', minWidth:'400px', maxWidth:'480px', width:'100%' },
  modalTitle: { fontFamily:"'Barlow Condensed'", fontSize:'var(--font-size-lg)', fontWeight:'700', letterSpacing:'2px' },
  field: { display:'flex', flexDirection:'column', gap:'6px' },
  label: { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'var(--text-dim)' },
  input: { background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'8px', padding:'10px 12px', color:'var(--text)', fontSize:'var(--font-size-sm)', outline:'none' },
  btnPri: { background:'#F4600C', color:'#fff', border:'none', borderRadius:'8px', padding:'10px 20px', fontSize:'var(--font-size-xs)', fontWeight:'700', cursor:'pointer' },
  btnSec: { background:'var(--border)', color:'var(--text)', border:'1px solid var(--border2)', borderRadius:'8px', padding:'10px 14px', fontSize:'var(--font-size-xs)', fontWeight:'700', cursor:'pointer' },
};
